import { ProductsRemapped } from "./mapping"
import { MapperOptions } from "./types"

/**
 * Wraps a pair of encode and decode functions for InputSearchProducts to a pair of encode and decode functions for SearchQuery.
 */
export default function createMapper<In, Out>({
    encode,
    decode
}: {
    encode(products: In, options: MapperOptions): ProductsRemapped<In, Out, keyof In>
    decode(products: Out, options: MapperOptions): ProductsRemapped<Out, In, keyof Out>
}) {
    return {
        encode<Q extends { products?: In }>(query: Q, options: MapperOptions) {
            return query?.products ? { ...query, products: encode(query.products, options) } : query
        },
        decode<Q extends { products?: Out }>(query: Q, options: MapperOptions) {
            return query?.products ? { ...query, products: decode(query.products, options) } : query
        }
    }
}
